/**
 * UserSection
 *
 * Wrapper that renders a `SectionHeader` and `UserTable` for a filtered
 * subset of users. Hides itself if there are no users in the section.
 */
import React from 'react';
import SectionHeader from './SectionHeader';
import UserTable from './UserTable';

const UserSection = ({
  sectionKey,
  icon,
  title,
  users,
  description,
  color = "purple",
  isCollapsed,
  onToggle,
  selectedEnterpriseId,
  onClearEnterpriseFilter,
  enterprises,
  onSelectEnterprise,
  tableConfig = {},
  userRowProps = {},
  getSortIcon,
  handleSort
}) => {
  if (users.length === 0) {
    return null;
  }

  return (
    <div className="mb-8 bg-white dark:bg-transparent border border-gray-200 dark:border-gray-700 rounded-lg overflow-hidden">
      <SectionHeader
        sectionKey={sectionKey}
        icon={icon}
        title={title}
        count={users.length}
        description={description}
        color={color}
        isCollapsed={isCollapsed}
        onToggle={onToggle}
        selectedEnterpriseId={selectedEnterpriseId}
        onClearEnterpriseFilter={onClearEnterpriseFilter}
        enterprises={enterprises}
        onSelectEnterprise={onSelectEnterprise}
      />
      
      {!isCollapsed && (
        <UserTable
          users={users}
          getSortIcon={getSortIcon}
          handleSort={handleSort}
          tableConfig={{
            ...tableConfig,
            tableId: sectionKey
          }}
          userRowProps={userRowProps}
        />
      )}
    </div>
  );
};

export default UserSection; 